import { IconProps } from 'interfaces';

const AlarmClock = ({ className = '~w-4/5 ~h-4/5' }: IconProps) => {
  return (
    <svg
      viewBox='0 0 45 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'
    >
      <path
        d='M38.4375 23.4375C38.4375 32.2395 31.302 39.375 22.5 39.375C13.698 39.375 6.5625 32.2395 6.5625 23.4375C6.5625 14.6355 13.698 7.5 22.5 7.5C31.302 7.5 38.4375 14.6355 38.4375 23.4375Z'
        fill='#E88800'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.025 35.0684L6.5625 39.3809'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M34.0125 35.0024L38.4375 39.3712'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.375 5.625L3.75 11.25'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M41.25 11.25L35.625 5.625'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.5 15V23.4375L26.25 27.1875'
        stroke='white'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default AlarmClock;
